import { Auction, MessagingSubscriptionCodeResponseDto } from '@/api';
import If, { Else } from '@/components/util/IF';
import { useFavorite } from '@/hooks/api/useFavorite';
import useAuction from '@/hooks/useAuction';
import useItemContext from '@/hooks/useItemContext';
import { getMessagingSubscriberCodeQueryFn } from '@/queries/account';
import { useQuery } from '@tanstack/react-query';
import { AnimatePresence, motion } from 'framer-motion';
import i18next from 'i18next';
import parsePhoneNumberFromString from 'libphonenumber-js';
import Link from 'next/link';
import React from 'react';

const ProductEcomSubscriberCode = () => {
    const { isFavorite } = useFavorite();
    const { item } = useItemContext();
    const { auction, lastBid, hasUserAuctionAccess } = useAuction(item, undefined, true);

    const { data: subscriberCode } = useQuery({
        refetchOnWindowFocus: true,
        queryKey: ['getMessagingSubscriberCodeQueryFn'],
        queryFn: getMessagingSubscriberCodeQueryFn,
        enabled: !!(auction && hasUserAuctionAccess && auction.status !== Auction.StatusEnum.Closed && auction.status !== Auction.StatusEnum.Done && auction.type === Auction.TypeEnum.Auction)
    });

    return (
        <AnimatePresence>
            <If condition={subscriberCode}>
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="flex items-center text-[14px] mt-[12px] leading-[14px]">
                    <span className="text-[14px] font-[500] text-grey15 leading-[1.2rem]">
                        <If condition={subscriberCode?.status === MessagingSubscriptionCodeResponseDto.StatusEnum.Pending && subscriberCode.code}>
                            {i18next.t('common:sms-subscription.send-code-to-susbscribe', {
                                code: subscriberCode?.code,
                                subscribe_phone_number: parsePhoneNumberFromString(subscriberCode?.subscribe_phone_number ?? '')?.formatNational({})
                            })} {' '}
                            <Link href="/terms-of-service#sms" target="_blank" className="underline">{i18next.t('common:sms-subscription.terms')}</Link>
                        </If>
                        <If condition={subscriberCode?.status === MessagingSubscriptionCodeResponseDto.StatusEnum.Subscribed}>
                            <If condition={!lastBid && !isFavorite(item?.id)}>
                                {i18next.t('common:sms-subscription.add-to-favorites-reminder')}
                                <Else>
                                    {i18next.t('common:sms-subscription.already-subscribed')}
                                </Else>
                            </If>
                        </If>
                        <If condition={subscriberCode?.status === MessagingSubscriptionCodeResponseDto.StatusEnum.UnSubscribed}>
                            {i18next.t('common:sms-subscription.send-start-to-susbscribe', {
                                subscribe_phone_number: parsePhoneNumberFromString(subscriberCode?.subscribe_phone_number ?? '')?.formatNational({})
                            })} {' '}
                            <Link href="/terms-of-service#sms" target="_blank" className="underline">{i18next.t('common:sms-subscription.terms')}</Link>
                        </If>
                    </span>
                </motion.div>
            </If>
        </AnimatePresence>
    );
};

export default ProductEcomSubscriberCode;
